const slotTableIdMapping: Record<string, string> = {
  'full-employment-snapshot': 'analytics_full_employee_contracts_current',
  'employment-snapshot': 'analytics_employee_contracts_current',
  'employment-point-in-time': 'analytics_employee_contracts_snapshot',
  'employment-history': 'analytics_employee_contracts_traceability',
  'employment-terminated-history': 'analytics_employee_contracts_terminated_traceability',
  'expenses-traceability': 'analytics_employee_expenses_traceability',
} as const satisfies Record<string, string>
export const getSlugFromTableId = (tableId: string): keyof typeof slotTableIdMapping | string => {
  const [_, tableIdSuffix] = tableId.split('__')
  const slug = Object.keys(slotTableIdMapping).find(
    (key) => slotTableIdMapping[key] === tableIdSuffix
  )

  // If no match we use tableId as the slug
  if (!slug) return tableId

  return slug
}

export const slugToTableId = (slug: string): string => {
  return slotTableIdMapping[slug] || slug
}
